import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import chatReducer from './slices/chat';
import dashboardReducer from './slices/dashboard';
import onlineReducer from './slices/online';
import pabxReducer from './slices/pabx';
import calendarReducer from './slices/calendar';
import uiConfigReducer from './slices/uiConfigSlice';
import internalChatReducer from './slices/internalChat';

// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['uiConfig'],
};

const rootReducer = combineReducers({
  dashboard: dashboardReducer,
  chat: chatReducer,
  internalChat: internalChatReducer,
  online: onlineReducer,
  calendar: calendarReducer,
  pabx: pabxReducer,
  uiConfig: uiConfigReducer,
});

export { rootPersistConfig, rootReducer };
